import { combineReducers } from 'redux';
import laps from './stopwatchReducer';
import reminders from './reminderReducer';
import user from './userReducer';
import idea from './ideaReducer';


export default combineReducers({laps,reminders,user,idea});


// WEBPACK FOOTER //
// ./src/reducers/index.js